module.exports = __webpack_public_path__ + "static/img/success.017287ac.jpg";